import { render, staticRenderFns } from "./WelcomeFollowDaily.vue?vue&type=template&id=2f0797db"
import script from "./WelcomeFollowDaily.vue?vue&type=script&lang=js"
export * from "./WelcomeFollowDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports